/*=========================================================================================
    File Name:
    Description:
    ----------------------------------------------------------------------------------------
    Item Name: GetBoarded UI Template
    Author: GetBoarded
    Author URL: https://www.getboarded.com
==========================================================================================*/

 import axios from '@/axios.js'
import store from "@/store/store";

export default {
  addCompany ({ commit }, company) {
    return new Promise((resolve, reject) => {
      /*axios
        .post("/api/data-list/products/", { item: item })
        .then(response => {
          commit("ADD_ITEM", Object.assign(item, { id: response.data.id }));
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });*/

      store.dispatch('company/create', company).then(res => {
        // commit("ADD_ITEM", res);
        resolve(res);
      }).catch(err => {
        console.log("user create failed", err)
        reject(err);
      })
    });
  },
  fetchCompanies ({ commit },query) {
    return new Promise((resolve, reject) => {
      /*axios.get('/api/user-management/users')
        .then((response) => {
          commit('SET_USERS', response.data)
          resolve(response)
        })
        .catch((error) => { reject(error) })*/

      /*const coach = new models.api.Coach({
        email: this.user_email,
        status: "mail_sent",
        email_verified: 0,
        password: null,
        username: null
      })*/
      store
        .dispatch("company/find",query)
        .then(res => {
          commit("SET_COMPANIES", res.data);
          resolve(res);
        })
        .catch(err => {
          console.log("companies could not be found", err);
          reject(err);
        });
    });
  },
  fetchCompany (context, companyId) {
    return new Promise((resolve, reject) => {
      /*axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })*/
      store
        .dispatch('company/get', companyId)
        .then(res => {
          window.$cookies.set('terminology', res.terminology, Infinity);
          // commit('SET_USERS', res.data)
          resolve(res);
        })
        .catch(err => {
          console.log("company could not be found", err);
          reject(err);
        });
    });
  },
  updateCompany (context, company) {
    return new Promise((resolve, reject) => {
      /*axios.get(`/api/user-management/users/${userId}`)
        .then((response) => {
          resolve(response)
        })
        .catch((error) => { reject(error) })*/
      store
        .dispatch('company/patch', [company.id, company])
        .then(res => {
          // commit('SET_USERS', res.data)
          resolve(res);
        })
        .catch(err => {
          console.log("company could not be found", err);
          reject(err);
        });
    });
  },
  removeCompany ({ commit }, userId) {
    return new Promise((resolve, reject) => {
      // axios.delete(`/api/user-management/users/${userId}`)
      //   .then((response) => {
      //     commit('REMOVE_RECORD', userId)
      //     resolve(response)
      //   })
      //   .catch((error) => { reject(error) })
      store
        .dispatch("company/remove", userId)
        .then(res => {
          commit("REMOVE_RECORD", userId);
          resolve(res);
         })
        .catch(err => {
          console.log("The selected coach could not be deleted", err);
          reject(err);
        });
    });
  },
  checkExistence ({ commit },query) {
    return new Promise((resolve, reject) => {
      store
        .dispatch("company/find",query)
        .then(res => {
          commit("SET_RESULT", res.data);
          resolve(res);
        })
        .catch(err => {
          console.log("can not be found", err);
          reject(err);
        });
    });
  }
};
